// extracted by mini-css-extract-plugin
export default {"tile-icon":"similar-to-youtK-NeB","tile-icon--super-offer":"similar-to-youEJGoCV"};